import React from "react";
import {
  Box,
  Typography,
  Card,
  CardActionArea,
  Avatar,
  useTheme,
} from "@mui/material";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import CampaignIcon from "@mui/icons-material/Campaign";
import MicIcon from "@mui/icons-material/Mic";
import { ReactComponent as SharkIcon } from '../assets/icons/shark-2.svg';
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import PsychologyIcon from "@mui/icons-material/Psychology";
import LockIcon from "@mui/icons-material/Lock";

//Lightbulb    //Psychology    //AutoAwesome

// Si el nombre es específicamente "AI Hackathon", mi orden sería:
// PsychologyIcon
// AutoAwesomeIcon      // innovación, IA generativa
// MemoryIcon           // IA más técnica
// LightbulbIcon        // ideas
// HubIcon              // sistemas/agentes
// ScienceIcon          // investigación
// SmartToyIcon

// import AttachMoney from "@mui/icons-material/AttachMoney";
// import MonetizationOn from "@mui/icons-material/MonetizationOn";
// import Handshake from "@mui/icons-material/Handshake";



const PitchTypeSelector = ({ pitchType, selected, onSelect, lang = "es", showBlocked = true }) => {
  const theme = useTheme();
  const name = pitchType[`name_${lang}`];
  const description = pitchType[`description_${lang}`];

  const getIconForPitchType = () => {
    const lower = name.toLowerCase();
    if (lower.includes("startup")) return <RocketLaunchIcon />;
    if (lower.includes("elevator")) return <TrendingUpIcon />;
    if (lower.includes("demo")) return <CampaignIcon />;
    if (lower.includes("shark")) return <SharkIcon style={{ width: 24, height: 24 }} />;
    if (lower.includes("medio") || lower.includes("media")) return <MicIcon />;
    if (lower.includes("grant")) return <WorkspacePremiumIcon />;
    if (lower.includes("hackathon")) return <PsychologyIcon style={{ width: 26, height: 26 }} />;
    return <RocketLaunchIcon />;
  };

  return (
    <Card
      sx={{
        borderRadius: 4,
        backgroundColor: selected ? "rgba(255, 255, 255, 0.20)" : "#ffffff",
        boxShadow: selected ? 6 : 2,
        transition: "all 0.3s ease",
        mb: 2,
        justifyContent: "flex-start",
        textAlign: "left",
        color: selected ? "#fff" : "#000",
        position: "relative",
      }}
    >
      <CardActionArea
        onClick={() => onSelect(pitchType.id)}
        sx={{
          p: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Avatar
          sx={{
            bgcolor: selected ? "#6a1b9a" : "#a855f7",
            color: "#fff",
            width: 48,
            height: 48,
            mr: 2,
          }}
        >
          {getIconForPitchType()}
        </Avatar>
        <Box sx={{ flex: 1 }}>
          <Typography
            variant="subtitle1"
            fontWeight={600}
            sx={{ color: selected ? "#ffffff" : "#000000" }}
          >
            {name}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: selected ? "rgba(255, 255, 255, 0.85)" : "#444",
            }}
          >
            {description}
          </Typography>
        </Box>
      </CardActionArea>
      {showBlocked && pitchType.blocked && (
        <LockIcon
          titleAccess="Not available"
          sx={{
            position: "absolute",
            top: 12,
            right: 12,
            color: selected ? "rgba(255,255,255,0.85)" : "#6b7280",
            fontSize: 20,
          }}
        />
      )}
    </Card>
  );
};

export default PitchTypeSelector;
